import React, { Component } from 'react';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import styled from 'styled-components';
import SimpleVerticalBarGraph from '../SimpleVerticalBarGraph';
import { I18n } from 'react-redux-i18n';

const TopNegociantsCardContainer = styled.div`
  .chartContainer {
    margin-top: 25px;
  }

  svg .recharts-label-list tspan {
    fill: white !important;
  }
`;

export default class TopNegociantsCard extends Component {
  constructor(props) {
    super(props);
  }

  formatData() {
    const data = this.props.data;
    const formattedData = data.map((negociant) => {
      return {
        name: negociant.negociant_name,
        label: {
          value: negociant.quantity_eq_75,
          locaCurrency: 'GBP',
          currency: 'EUR'
        },
        value: negociant.quantity_eq_75,
        currency: 'GBP'
      };
    });
    return formattedData;
  }

  render() {
    const formattedData = this.formatData();
    return (
      <TopNegociantsCardContainer>
        <Card id="directVerticalGraph">
          <CardHeader
            title={I18n.t('negoce.pilotage_interne.topDealer.title')}
            fontSize="20px"
          />
          <SimpleVerticalBarGraph data={formattedData} />
        </Card>
      </TopNegociantsCardContainer>
    );
  }
}
